import { useFilterGroups } from 'framework-listing-lib/hooks/useListingLibFilters';
import { useEffect, useMemo } from 'react';
import { flattenFilterGroups } from 'framework-listing-lib/utils/filters';
import { useHistory } from 'react-router-dom';
export default function useFrameworkFoldersRouteUpdate() {
  const filterGroups = useFilterGroups();
  const history = useHistory();
  const filters = useMemo(() => flattenFilterGroups(filterGroups), [filterGroups]);
  useEffect(() => {
    const folderFilter = filters.find(filter => filter.property === 'hs_folder_id' && filter.operator === 'EQ');

    // value in is needed to type it correctly
    if (folderFilter && 'value' in folderFilter) {
      if (folderFilter.value === 0) {
        history.replace(`/manage/folders`);
      } else {
        history.replace(`/manage/folders/${folderFilter.value}`);
      }
    }
  }, [filters, history]);
}